export const SaveFile = {
  "Modal": {
    "Title": "Save File",
    "FileName": "File name",
    "FileType": "File type",
    "SpecialCharacters": "A file name can't contain any of the following characters: \\\\ / : * ? \" < > | and can't start with #",
    "AddUser": "Add an account",
    "RefreshFolder": "Reload",
    "SignOut": "Sign out",
    "NewFolder": "New folder",
    "defaultNewFolderName": "Untitled folder",
    "FolderNameExist": "The folder name has already existed."
  }
}